'use strict';

export default function() {
	return function filter(string) {
		if (!string) return '';
		var result = string.replace( /([A-Z])/g, " $1" );
		return result.charAt(0).toUpperCase() + result.slice(1);
	}
}
